import { GOOGLE_TRANSLATE_SELECT_LANGUAGES as e } from "./index7.mjs";
const a = {
  /** select dropdown option */
  languages: {
    type: Array,
    default: () => e
  },
  /** select input default language*/
  defaultLanguageCode: {
    type: String,
    default: "en"
  },
  /** page(browser) content language */
  defaultPageLanguageCode: {
    type: String,
    default: "en"
  },
  /** get browser default language  */
  fetchBrowserLanguage: {
    type: Boolean,
    default: !0
  },
  /** select dropdown animate */
  animateTimeout: {
    type: Number,
    default: 150
  },
  dropdownClassName: {
    type: String,
    default: ""
  },
  dropdownStyle: {
    type: Object,
    default: () => ({})
  },
  showArrow: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "hover"
  }
};
export {
  a as googleTranslateProps
};
//# sourceMappingURL=index3.mjs.map
